import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-brands-svg-icons";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { callautopopulate } from "../../../services/callautopop";
import { DateTime } from "luxon";
import { useCommon } from "../../Common/useCommon";
import { dateConvert } from "../../../utils/Helper";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { MuiCss } from "../../../utils/Helper";
import projectStore from "../../../Store/projectStore";
import { SkeletonContainer } from "../../../components/Loader/Loader";

export const useTeamlist = () => {
    const { onSortChanged, getValuePermission } = useCommon();
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [loader, setLoader] = useState({ grid: false, tags: false });
    const [rowData, setRowData] = useState([]);
    const [allRowData, setAllRowData] = useState([]);
    const categories = useRef([]);
    const gridRef = useRef(null);
    const tagRef = useRef(null)
    const userMapRef = useRef(null);
    const [showPopUp, setShowPopUp] = useState(false)
    const [savedColumnState, setSavedColumnState] = useState([]);
    const [filterValues, setFilterValues] = useState({
        project: [],
        lead: [],
        tech: [],
        startDate: null,
        endDate: null,
        isActiveBtn: 'active',
        hoveredRange: [],
        type: 'joining',
        callApi: false,
        user_status: [],
        calendar_unit: [],
        hide_calendar_unit_dropdown: false,
        view_group_wise: false
    })
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [handleData, setHandleData] = useState({
        remark: '',
        gridData: '',
        isRejectClicked: false,
        statusId: [],
        decision: '',
    })
    const [mapUser, setmapUser] = useState({
        showPopUp: false,
        users: [],
        selectedUser: [],
        currentUser: { selectedName: "", selectedCode: "" },
        products: []
    })
    const users = useRef([])
    const products = useRef([])
    const [mapColDef] = useState([
        {
            field: "employee_id",
            headerName: "Employee ID",
            width: "50%",
            minWidth: 125,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "user_display_name",
            headerName: "User Name",
            width: "50%",
            minWidth: 125,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "map_datetime",
            headerName: "Mapped Date Time",
            width: "70%",
            minWidth: 150,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                const formatedDate = dateConvert(params.data?.verification_datetime, 'date-time-months')
                return (
                    <div>{formatedDate} </div>
                )
            }
        },
        {
            field: "from_date",
            headerName: "From Date",
            width: "70%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                const formatedDate = dateConvert(params?.data?.from_date, 'day-mon-year')
                return (
                    <div>{params.data?.from_date ? formatedDate : "-"} </div>
                )
            }
        },
        {
            field: "to_date",
            headerName: "To Date",
            width: "70%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                const formatedDate = dateConvert(params.data?.to_date, 'day-mon-year')
                return (
                    <div>{params.data?.to_date ? formatedDate : "-"} </div>
                )
            }
        },
        {
            field: "verified_by_name",
            headerName: "Verified By",
            width: "50%",
            minWidth: 125,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,

        },
        {
            field: "status",
            headerName: "Status",
            width: "50%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div>
                        {(!params?.data?.is_verified && !params.data?.is_auto_verified && !params.data?.is_requested && !params.data?.is_action_perform)
                            && (
                                <FontAwesomeIcon
                                    style={{ color: "#FFD700", cursor: "pointer" }}
                                    icon="fa-solid fa-clock"
                                    onClick={() => handleUserMapRequest(params, 'status')}

                                />
                            )}
                        {params?.data?.is_verified && (
                            <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "#4CAF50" }}
                            />
                        )}
                        {params?.data?.is_auto_verified && (
                            <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "#800080" }}
                            />
                        )}
                        {params?.data?.is_requested && (

                            <div><input type="radio" name="request" checked={params?.data?.is_action_perform} onChange={() => handleUserMapRequest(params, 'upsert')} />Approve</div>
                        )}
                    </div>
                )
            }
        },
        {
            field: "",
            headerName: "Delete",
            width: "50%",
            minWidth: 125,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div>
                        <FontAwesomeIcon icon="fa solid fa-trash" style={{ color: "red" }} onClick={() => handleRemoveUserFromHierarchy(params)} />
                    </div>
                )
            }
        }

    ])
    const [mapRowData, setmapRowData] = useState([])
    const [userEditData, setUserEditData] = useState({});
    const [groupOpts, setGroupOpts] = useState([]);
    const [showNotes, setShowNotes] = useState(false);
    const [notesFlag, setNotesFlag] = useState(false);
    const [notesUser, setNotesUser] = useState({});
    const [jiraUser, setJiraUser] = useState({ show: false, user: {} });
    const [jiraAccessValues, setJiraAccessValues] = useState({ project: null, group: null });
    const [jiraBtnLoader, setJiraBtnLoader] = useState(false);
    const [options, setOptions] = useState({});
    const [mappingPopup, setMappingPopup] = useState(false);
    const [addUserPopup, setAddUserPopup] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState({
        data: '',
        show: false
    })
    const location = useLocation().state;
    const [tab, setTab] = useState("");
    const [createChart, setCreateChart] = useState(false);
    const [showChangeManager, setShowChangeManager] = useState({ visible: false, data: {} });
    const [search, setSearch] = useState("");
    const autoGroupColumnDef = {
        headerName: "Group Name",
        pinned: "left",
        width: 180,
        cellRendererParams: {
            suppressCount: true
        }
    };
    const columnDefs = [
        {
            field: "user_group_name",
            headerName: "Group Name",
            rowGroup: filterValues?.view_group_wise,
            hide: true,
            width: 150,
        },
        {
            field: "edit",
            headerName: "Edit",
            width: 50,
            pinned: "right",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.data?.user_display_name && <div style={{ cursor: "pointer" }} onClick={() => { setUserEditData(params?.data); setAddUserPopup(true); }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></div>}</div>
                )
            }
        },
        {
            field: "employee_id",
            headerName: "Employee Id",
            filter: true,
            width: "30%",
            minWidth: 100,
            pinned: "left",
            cellStyle: { textAlign: "center" }
        },
        {
            field: "user_display_name",
            headerName: "Employee Name",
            filter: true,
            width: "40%",
            minWidth: 130,
            suppressHeaderMenuButton: true,
            pinned: "left",
            cellRenderer: function (params) {
                const check = params?.data?.is_leaving_date || params?.data?.is_resignation_date
                const today = new Date();
                const targetDate = new Date(params?.data?.leaving_date);
                today.setHours(0, 0, 0, 0);
                targetDate.setHours(0, 0, 0, 0);
                const diffInMilliseconds = targetDate.getTime() - today.getTime();
                const oneDay = 1000 * 60 * 60 * 24;
                const diffInDays = Math.round(diffInMilliseconds / oneDay);
                return (
                    <div className="">
                        {params?.data?.user_display_name !== undefined &&
                            <div className="d-flex gap-1">
                                <div className="">
                                    <div
                                        className="rounded-circle position-relative "
                                        style={{ border: check && "2px solid rgb(188, 7, 7)", width: "30px", height: "30px" }}
                                        title={params?.data?.is_leaving_date ? "Leaving in 3 days" : params?.data?.is_resignation_date ? "Resign in last 2 days" : params.data?.user_display_name}
                                    >
                                        <img
                                            src={`${params.data?.image_url}?nocache=${Date.now()}`}
                                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }}
                                            className="rounded-circle"
                                            width={20}
                                            height={20}
                                            alt=" "
                                        />
                                        {
                                            (params?.data?.leaving_date && diffInDays > 0) && <div style={{ position: "absolute", top: "-2px", right: "0px", background: "#0055cc", lineHeight: "normal", borderRadius: "10px", color: "white", padding: "0px 2px" }} title="Leaving Days" >{diffInDays}</div>
                                        }
                                    </div>
                                </div>
                                {params.data?.user_display_name}
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: "is_new_user",
            headerName: "Access",
            width: "30%",
            minWidth: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return <div>
                    {
                        params?.data?.user_display_name && <FontAwesomeIcon icon={`fa-solid ${params?.data?.is_new_user ? "fa-lock" : "fa-lock-open"}`} className={` ${params?.data?.is_new_user ? "text-warning" : "text-success"} c-pointer`} onClick={() => setConfirmationPopup({ show: true, data: params?.data })} />
                    }
                </div>
            }
        },
        {
            field: "jira_data",
            headerName: "Jira Access",
            width: 50,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                const data = params?.data?.jira_data;
                let status = 0;
                if (!data) {
                    status = 0;
                } else if (data?.user_code && !data?.product_code && !data?.product_accountId && !data?.product_token) {
                    status = 1
                } else if (data?.product_code && (!data?.product_accountId || !data?.product_token)) {
                    status = 2;
                } else if (data?.product_code && data?.product_accountId && data?.product_token) {
                    status = 3
                }
                return status;
            },
            cellRenderer: (params) => {
                const data = params?.data?.jira_data;
                let status = "";
                if (!data) {
                    status = "new";
                } else if (data?.user_code && !data?.product_code && !data?.product_accountId && !data?.product_token) {
                    status = "mail-sent"
                } else if (data?.product_code && (!data?.product_accountId || !data?.product_token)) {
                    status = "account-created";
                } else if (data?.product_code && data?.product_accountId && data?.product_token) {
                    status = "done"
                }
                return (
                    <div>{params?.data?.user_display_name && (status === "new" ?
                        <div className="c-pointer text-danger" title="New User" onClick={() => { setJiraUser({ show: true, user: params?.data }); setJiraAccessValues({ project: null, group: null }) }}>
                            <FontAwesomeIcon icon={Icons?.faAtlassian} />
                        </div> :
                        status === "mail-sent" ?
                            <div className="text-warning" title="Mail sent">
                                <FontAwesomeIcon icon="fa-solid fa-envelope-circle-check" />
                            </div> :
                            status === "account-created" ?
                                <div className="text-primary" title="JIRA Account Created">
                                    <FontAwesomeIcon icon="fa-solid fa-id-card" />
                                </div> :
                                status === "done" ?
                                    <div className="text-success" title="Integration Completed">
                                        <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: '#15bb15cf' }} />
                                    </div> :
                                    <></>
                    )}</div>
                )
            }
        },
        {
            field: "user_status_name",
            headerName: "Status",
            width: 120,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {
                            params?.data?.transition_pending_count ? <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" className="pe-1" /> : ""
                        }
                        {params?.value || ""}
                    </div>
                )
            }
        },
        {
            field: "user_tags",
            headerName: "Tags",
            width: 250,
            autoHeight: true,
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) =>
                params?.data?.user_display_name && (
                    <div className="w100">
                        {loader?.tags?.[params?.node?.rowIndex] ? <div style={{ height: "30px" }}><SkeletonContainer /></div> :
                            <Autocomplete
                                size="small"
                                multiple
                                disableCloseOnSelect
                                freeSolo
                                limitTags={1}
                                className="common-autocomplete d-flex align-items-center"
                                sx={{ ...MuiCss, width: "100%", "& .MuiChip-deleteIcon": { display: "none" } }}
                                options={options?.user_tags || []}
                                value={(params?.data?.tag_ids || [])?.map((tag) => {
                                    if (typeof tag === "object") return options?.user_tags?.find((t) => t?.tag_id === tag?.tag_id || t?.tag_name === tag?.tag_name) || tag;
                                    return options?.user_tags?.find((t) => t?.tag_id === tag);
                                })?.filter(Boolean)}

                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    return option?.tag_name ? `${option.tag_name}` : "";
                                }}

                                // isOptionEqualToValue={(o, v) => o?.tag_id === v?.tag_id}
                                filterOptions={(optionsArr = [], paramsInput) => {
                                    const input = paramsInput?.inputValue?.trim() || "";

                                    let filtered = optionsArr?.filter((opt) => opt?.tag_name?.toLowerCase()?.includes(input?.toLowerCase()));

                                    const isExisting = optionsArr?.some((opt) => opt?.tag_name?.toLowerCase() === input?.toLowerCase());

                                    if (input && !isExisting) {
                                        filtered?.push({
                                            tag_id: 0,
                                            tag_name: input,
                                            inputValue: input
                                        });
                                    }

                                    return filtered;
                                }}

                                renderOption={(props, option, { selected }) => (
                                    <li {...props} key={option.tag_id}>
                                        <input
                                            type="checkbox"
                                            checked={selected}
                                            readOnly
                                            style={{ marginRight: 8 }}
                                        />
                                        {option.inputValue
                                            ? option.inputValue
                                            : `${option.tag_name} `}
                                    </li>
                                )}

                                onChange={(e, newValues) => {
                                    if (newValues?.length === 0) handletagChange([], params.data?.user_code, params);
                                    let updatedTags = (newValues || []).map((val) => {
                                        if (typeof val === "string") return { tag_id: 0, tag_name: val.trim() };
                                        if (val?.inputValue) return { tag_id: 0, tag_name: val.inputValue.trim() };
                                        return val;
                                    });

                                    params.node.setData({
                                        ...params.data,
                                        tag_ids: updatedTags,
                                        isTagChanged: true
                                    });
                                }}

                                renderInput={(paramsInput) => (
                                    <TextField
                                        {...paramsInput}
                                        size="small"
                                        placeholder={!(params.data?.tag_ids?.length) ? "Select Tags" : ""}
                                        onBlur={() => { if (params.data?.isTagChanged) { handletagChange(params.data?.tag_ids || [], params.data?.user_code, params); params.node.setData({ ...params.data, isTagChanged: false }); } }}
                                    />
                                )}
                            />}
                    </div>
                )
        },
        {
            field: "user_category_name",
            headerName: "Category",
            width: 120,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "reporting_manager_name",
            headerName: "Reporting Manager",
            filter: true,
            width: "50%",
            minWidth: 125,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
            cellRenderer: (params) => {
                const isClient = params?.data?.is_client;
                return <div className="d-flex justify-content-between">
                    <div className="w90 text-truncate" title={params?.value}>{params?.value}</div>
                    {params?.value && <div className="pe-1 c-pointer w10" title={isClient ? "Client: action disabled" : "Request to change Reporting Manager"} onClick={() => { if (isClient) { return; } setShowChangeManager({ visible: true, data: params?.data }); }} style={{ background: "none", border: "none", padding: 0, cursor: isClient ? "auto" : "pointer" }}><FontAwesomeIcon icon="fa-solid fa-envelope" /></div>} </div>
            }
        },
        {
            field: "email_id",
            headerName: "Email",
            filter: true,
            width: "30%",
            minWidth: 150,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "left" },
        },
        {
            field: "primary_phone",
            headerName: "Mobile",
            width: "30%",
            cellStyle: { textAlign: "center" },
            minWidth: 130,
            suppressHeaderMenuButton: true,
        },
        {
            field: "role_on_project",
            headerName: "Role On Project",
            filter: true,
            width: "100%",
            minWidth: 200,
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div>
                        {params.data?.role_on_project !== undefined &&
                            <div>{params.data?.role_on_project?.split(",")?.join(", ")}</div>
                        }
                    </div>
                )
            }
        },
        {
            field: "primary_skill_1",
            headerName: "Primary TechnoLogy",
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
            filter: true,
            headerClass: "header-wrap"
        },
        {
            field: "secondary_skill_1",
            headerName: "Secondary TechnoLogy",
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
            filter: true,
            headerClass: "header-wrap"
        },
        {
            field: "confirmation_date",
            headerName: "Confirmation Date",
            filter: true,
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            headerClass: "header-wrap",
            valueGetter: params => params.data?.confirmation_date ? DateTime.fromISO(params.data?.confirmation_date).toFormat('dd MMM yyyy') : '',
        },
        {
            field: "joining_date",
            headerName: "Join Date",
            filter: true,
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            valueGetter: params => params.data?.joining_date ? DateTime.fromISO(params.data?.joining_date).toFormat('dd MMM yyyy') : '',
        },
        {
            field: "srkay_exp",
            headerName: "Company Age",
            filter: true,
            width: "30%",
            minWidth: 120,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "total_work_experience",
            headerName: "Total Experience",
            filter: true,
            width: "30%",
            minWidth: 120,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
            headerClass: "header-wrap"
        },

        {
            field: "resignation_date",
            headerName: "Resign Date",
            filter: true,
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: filterValues?.isActiveBtn === "inactive",
            cellRenderer: function (params) {
                const formattedDate = DateTime.fromISO(params.data?.resignation_date).toFormat('dd MMM yyyy')
                return (
                    <div>
                        {params.data?.resignation_date && <div >{formattedDate}</div>}
                    </div>
                )
            }
        },
        {
            field: "leaving_date",
            headerName: "Leave Date",
            filter: true,
            width: "30%",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: filterValues?.isActiveBtn === "inactive",
            valueGetter: params => params.data?.leaving_date ? DateTime.fromISO(params.data?.leaving_date).toFormat('dd MMM yyyy') : '',
        },
        {
            field: "business_unit",
            headerName: "Business Unit",
            filter: true,
            width: "20%",
            minWidth: 90,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "sub_business_unit",
            headerName: "Sub Business Unit",
            filter: true,
            width: "30%",
            minWidth: 120,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "sub_business_unit_2",
            headerName: "Sub Business Unit 2",
            filter: true,
            width: "30%",
            minWidth: 120,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "location",
            headerName: "Location",
            filter: true,
            width: "20%",
            minWidth: 70,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },

        {
            field: "gender",
            headerName: "Gender",
            filter: true,
            width: "30%",
            minWidth: 60,
            cellStyle: { textAlign: "left" },
            suppressHeaderMenuButton: true,
        },
        {
            field: "employee_status",
            headerName: "Status",
            width: "25%",
            minWidth: 60,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: (params) => {
                return (
                    <div>
                        {params.data?.employee_status &&
                            <div style={{ color: '#15bb15cf' }}><FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ height: '18px' }} /></div>
                        }
                    </div>
                )
            }
        },
        {
            field: "primary_project_name",
            headerName: "Primary Project",
            filter: true,
            width: "40%",
            minWidth: 125,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: (params) => {
                return (
                    <div title={params?.data?.primary_project_name}>
                        {params?.data?.primary_project_name}
                    </div>
                );
            }
        },
        {
            field: "secondary_project_name",
            headerName: "Secondary Project",
            filter: true,
            width: "30%",
            minWidth: 125,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: (params) => {
                return (
                    <div title={params?.data?.secondary_project_name}>
                        {params?.data?.secondary_project_name}
                    </div>
                )
            }
        },
        {
            field: "state",
            headerName: "State",
            filter: true,
            width: "40%",
            minWidth: 100,
            cellStyle: { textAlign: "left" }
        },
        {
            field: "present_count",
            headerName: "Present",
            width: "40%",
            minWidth: 80,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "absent_count",
            headerName: "Absent",
            width: "40%",
            minWidth: 80,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "regularize_count",
            headerName: "Regularize",
            width: "40%",
            minWidth: 80,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "wfh_count",
            headerName: "Work from home",
            width: "40%",
            minWidth: 80,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "outdoor_count",
            headerName: "Outdoor",
            width: "40%",
            minWidth: 80,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "total_gatepass_hours",
            headerName: "Gate Pass Hours",
            width: "40%",
            minWidth: 80,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "ios_device_id",
            headerName: "Apple Id",
            width: 140,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="text-truncate" title={params?.value}>{params?.value}</div>
                )
            }
        },
        {
            field: "user_hierarchy_count",
            headerName: "Map User",
            width: "30%",
            minWidth: 50,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return <div className="d-flex justify-content-between align-items-center gap-1">
                    {params?.data?.user_display_name &&
                        <div>
                            <FontAwesomeIcon style={{ cursor: "pointer", position: "relative" }} icon="fa-solid fa-link" onClick={() => { setmapUser((prevState) => ({ ...prevState, showPopUp: true, currentUser: { 'selectedName': params.data?.user_display_name, 'selectedCode': params.data?.user_code } })) }} />
                            <span className="bg-primary text-white rounded-circle px-1" style={{ fontWeight: 500, visibility: params?.data?.user_hierarchy_count !== 0 && params?.data?.user_hierarchy_count !== undefined ? "visible" : "hidden" }}>
                                {params?.data?.user_hierarchy_count}
                            </span>
                        </div>
                    }
                </div>
            }
        },
        {
            field: "notes_count",
            headerName: "Note",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div style={{ height: "100%" }}>
                        {params?.data?.user_display_name &&
                            <div style={{ height: "100%" }} className="c-pointer d-flex gap-1 justify-content-center align-items-center w100" onClick={() => { setNotesUser(params?.data); setShowNotes(true); }}>
                                <div className="d-flex gap-1" title={params?.data?.is_notes_pending ? "Notes not taken since 3 month" : ""}>
                                    <FontAwesomeIcon icon="fa-solid fa-note-sticky" />
                                    <FontAwesomeIcon icon="fa-solid fa-exclamation" className="text-warning fw-bold" style={{ visibility: params?.data?.is_notes_pending ? "visible" : "hidden", fontSize: "16px" }} />
                                </div>
                                <div className="custom-bagde ms-1 d-flex gap-1 justify-content-center align-items-center" style={{ visibility: params?.data?.notes_count ? "visible" : "hidden" }}>{params?.data?.notes_count || 0}</div>
                            </div>
                        }
                    </div >
                )
            }
        },


    ]


    useEffect(() => {
        if (location?.team === "chart-config") {
            setTab("chart")
        } else {
            setTab("");
        }
    }, [location])

    useEffect(() => {
        const hide = getValuePermission("team_list_unit_dropdown");
        sessionStorage.removeItem("user_tags")
        setFilterValues((prev) => ({ ...prev, hide_calendar_unit_dropdown: hide }))
        callautopopulate("projects", "project_leads", "user_technologies", "users", "user_info", "attribute_types", "attribute_units", "user_status", "day_calendar_groups", "user_tags").then(res => {
            // set group id in leads dropdown
            const leads = res?.project_leads?.map(item => { return { ...item, group_id: _.findWhere(res?.users, { user_code: item?.user_code })?.group_id } })

            setOptions({
                projects: res?.projects?.sort((a, b) => a?.project_name?.localeCompare(b?.project_name)),
                leads: _.sortBy(leads, 'user_display_name'),
                technologies: _.sortBy(res?.user_technologies, 'primary_skill_1'),
                users: _.sortBy(res?.users, "user_display_name"),
                attribute: _.sortBy(res?.attribute_types, "attribute_type_code"),
                unit: _.sortBy(res?.attribute_units, "attribute_type_desc"),
                unitStore: _.sortBy(res?.attribute_units, "attribute_type_desc"),
                user_status: _.sortBy(res?.user_status, "user_status_name"),
                calendar_units: _.sortBy(res?.day_calendar_groups, "group_name"),
                user_tags: _.sortBy(res?.user_tags, "tag_name"),
            })
            const loggedInUserUnit = hide ? {} : _.findWhere(res?.users, { user_code: res?.user_info?.[0]?.user_code })?.group_id;
            const data = _.filter(leads, { user_code: res?.user_info?.[0]?.user_code });
            setFilterValues((prev) => ({ ...prev, lead: data, isApiCall: true, calendar_unit: _.filter(res?.day_calendar_groups, { group_id: loggedInUserUnit }), view_group_wise: res?.user_info?.[0]?.is_user_grouping_view || false }));
        })
    }, [])

    useEffect(() => {
        if (!_.isEmpty(filterValues?.calendar_unit)) {
            const filtered_users = _.filter(options?.users, item => _.pluck(filterValues?.calendar_unit, "group_id")?.includes(item?.group_id));
            const filtered_leads = _.filter(options?.leads, item => _.pluck(filterValues?.calendar_unit, "group_id")?.includes(item?.group_id));
            setOptions((prev) => ({ ...prev, filtered_users, filtered_leads }));

            setFilterValues((prev) => ({ ...prev, "users": _.filter(filterValues?.users, item => filtered_users?.includes(item)), "lead": _.filter(filterValues?.lead, item => filtered_leads?.includes(item)) }))
        } else {
            setOptions((prev) => ({ ...prev, filtered_users: options?.users, filtered_leads: options?.leads }));
        }
    }, [filterValues?.calendar_unit])

    useEffect(() => {
        const selectedAttributeDescriptions = filterValues?.attribute?.map(item => item.attribute_type_desc) || [];
        const validUnits = options?.unitStore?.filter(unit =>
            selectedAttributeDescriptions.includes(unit.attribute_type_desc)
        ) || [];
        const filteredUnits = Array.isArray(filterValues.unit)
            ? filterValues.unit.filter(unit =>
                validUnits.some(validUnit => validUnit.attribute_unit_desc === unit.attribute_unit_desc)
            )
            : [];
        setOptions(prev => ({ ...prev, unit: validUnits }));
        setFilterValues(prev => ({
            ...prev,
            unit: filteredUnits.length === 0 ? null : filteredUnits,
            isChange: true
        }));
    }, [filterValues.attribute]);

    useEffect(() => {
        filterValues?.apiCall && getTeamOverViewList()
    }, [filterValues?.apiCall, filterValues?.isActiveBtn, filterValues?.type])


    useEffect(() => {
        if (mapUser.currentUser?.selectedName !== '' && mapUser.currentUser?.selectedCode !== '') {
            GetUserHierarchy()
        }
    }, [mapUser.currentUser])

    const handleUserMapRequest = (event, type) => {

        if (type === 'status') {
            if (!event.data.is_auto_verified && !event.data.is_verified) {
                event.data['is_requested'] = true
            }
        } else {
            // call api
            event.data['is_requested'] = false
            event.data['is_action_perform'] = true
            event.data['status'] = 'approved'
            handleUserUpsertHierachy('is_verified', event)
        }
        let updateData = [...userMapRef.current.props.rowData]
        const rowNode = userMapRef.current.api.getDisplayedRowAtIndex(event.node.rowIndex);
        rowNode.setData(updateData[event.node.rowIndex]);
    }

    const onGridReady = params => {
        if (params.api) {
            if (!savedColumnState) {
                setSavedColumnState(params.api.getColumnState());
            } else {
                params.api.applyColumnState({ state: savedColumnState });
            }
        }
    };
    const onColumnMoved = params => {
        if (params.api) {
            const columnState = params.api.getColumnState();
            setSavedColumnState(columnState);
        }
    };

    useEffect(() => {
        if (gridRef.current && savedColumnState) {
            gridRef?.current?.api?.applyColumnState({ state: savedColumnState });
        }
    }, [rowData]);

    useEffect(() => {
        callautopopulate("control_center_user_category", "user_activation_status", "users", "products", "groups").then(res => {
            let data = res?.control_center_user_category ? _.sortBy(res.control_center_user_category, "user_category_name") : []
            categories.current = [...data]
            setHandleData((prevState) => ({ ...prevState, statusId: res?.user_activation_status }))
            setmapUser((prevState) => ({
                ...prevState, users: _.sortBy(_.uniq(res?.users, (item) => item.user_code), "user_display_name"),
                products: _.sortBy(_.uniq(res?.products, (item) => item.product_code), "product_name")
            }))
            const groups = res?.groups?.sort((a, b) => { return a?.group_name?.toLowerCase()?.localeCompare(b?.group_name?.toLowerCase()) });
            setGroupOpts(groups);
        });
    }, []);

    useEffect(() => {
        users.current = mapUser.users
    }, [mapUser.users]);

    useEffect(() => {
        products.current = mapUser.products
    }, [mapUser.products]);

    // API calling for get team overview list
    const getTeamOverViewList = async (fromRefresh) => {

        const projects = _.pluck(filterValues.projects, 'project_id')
        const tech = _.pluck(filterValues.user_technologies, 'primary_skill_1')
        const payload = {
            "project_ids": projects.length > 0 ? projects.toString() : '',
            "project_lead_user_code": _.pluck(filterValues.project_leads, 'user_code').length > 0 ? _.pluck(filterValues.project_leads, 'user_code').toString() : '',
            "technologies": tech.length > 0 ? tech.toString() : '',
            "from_date": filterValues?.hoveredRange?.[0]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || "",
            "to_date": filterValues?.hoveredRange?.[1]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || "",
            "is_active": filterValues.isActiveBtn === 'active' ? true : false,
            "users": _.pluck(filterValues.users, 'user_code').toString(),
            "criteria_key": (filterValues?.hoveredRange?.[0] || filterValues?.hoveredRange?.[1]) ? filterValues?.type : "",
            "year": filterValues?.year || 0,
            "month": filterValues?.month || 0,
            "attribute_types": _.pluck(filterValues?.attribute, "attribute_type_desc").toString(),
            "attribute_units": _.pluck(filterValues?.unit, "attribute_unit_desc").toString() || "",
            "user_status_keys": _.pluck(filterValues?.user_status, "user_status_key")?.toString(),
            "group_id": _.pluck(filterValues?.day_calendar_groups, "group_id")?.toString() || "",
            "tag_ids": _.pluck(filterValues?.user_tags, "tag_id")?.toString(),
        }
        setLoader((prev) => ({ ...prev, grid: true }));
        try {
            let isUserRoles = {}
            const res = await services.getInvokeRemote('POST', Urls('GETTEAMOVERVIEWLISTVIEWDETAILS'), payload)
            // Process user roles and set cell renderers
            if (!_.isEmpty(res.body.data.user_roles)) {
                res.body.data.user_roles.filter(user => {
                    const roles = _.findWhere(res.body.data.list_view, { user_code: user.user_code })
                    if (!_.isEmpty(roles)) {
                        roles[user.project_role_name] = true
                        const colField = _.findWhere(isUserRoles.children, { field: user.project_role_name })
                        if (!_.isEmpty(colField)) {
                            colField['cellRenderer'] = function (params) {
                                return (
                                    <div>{params.data?.[user.project_role_name] ? <div style={{ color: '#15bb15cf' }}><FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ height: '18px' }} /></div> : null}
                                    </div>
                                )
                            }
                            colField['cellStyle'] = { textAlign: 'center' }
                        }
                    }
                })
            }

            res?.body?.data?.list_view?.forEach((list) => {
                if (list.image_url) {
                    list.image_url = `${list.image_url}?t=${new Date().getTime()}`;
                }
            })



            const unit = res?.body?.data?.user_unit_data;
            if (!_.isEmpty(unit)) {
                res?.body?.data?.list_view?.forEach((list) => {
                    const findData = _.filter(unit, { user_code: list?.user_code });
                    if (!_.isEmpty(findData)) {
                        list["unit_data"] = findData
                    }
                    if (userEditData?.user_code === list?.user_code) {
                        setUserEditData(list);
                    }
                })
            }
            // set punctuality data
            const punctuality = res?.body?.data?.punctuality_data;
            if (!_.isEmpty(punctuality)) {
                res?.body?.data?.list_view?.forEach((list) => {
                    const findPunctuality = _.findWhere(punctuality, { user_code: list.user_code });
                    if (!_.isEmpty(findPunctuality)) {
                        list["present_count"] = findPunctuality.present_count;
                        list["absent_count"] = findPunctuality.absent_count;
                        list["regularize_count"] = findPunctuality.regularize_count;
                        list["wfh_count"] = findPunctuality.wfh_count;
                        list["outdoor_count"] = findPunctuality.outdoor_count;
                        list["total_gatepass_hours"] = findPunctuality.total_gatepass_hours;
                    }
                })
            }

            // set notes count
            const notesCount = res?.body?.data?.user_note_counts
            if (!_.isEmpty(notesCount)) {
                res?.body?.data?.list_view?.forEach((list) => {
                    const findData = _.findWhere(notesCount, { user_code: list?.user_code });
                    if (!_.isEmpty(findData)) {
                        list["notes_count"] = findData?.user_notes_count
                    }
                })
            }

            // set jira access status data
            const jiraData = res?.body?.data?.user_product
            if (!_.isEmpty(jiraData)) {
                res?.body?.data?.list_view?.forEach((list) => {
                    const findData = _.findWhere(jiraData, { user_code: list?.user_code });
                    if (!_.isEmpty(findData)) {
                        list["jira_data"] = findData;
                    }
                })
            }

            let rowdata = _.uniq(res?.body?.data?.list_view.map(list => ({ ...list, tag_ids: list.tag_ids ? list.tag_ids.split(",").map(Number) : [] })), item => item.user_code);
            rowdata.sort((a, b) => { return a.manager_name?.localeCompare(b.manager_name) || a.user_display_name?.localeCompare(b.user_display_name) });
            setRowData(rowdata);
            setAllRowData(rowdata);
            setNotesFlag(false);
            setFilterValues((prev) => ({ ...prev, isChange: false, apiCall: false }));

            search?.trim()?.length > 0 && onFilterTextBoxChanged(search, rowdata);

            if (fromRefresh) {
                await callautopopulate("user_info")?.then(res => {
                    setFilterValues((prev) => ({ ...prev, view_group_wise: res?.user_info?.[0]?.is_user_grouping_view || false }));
                })
            }

        } catch (error) {
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            console.error(error);
        } finally {
            setLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const handletagChange = async (tagId, userCode, params) => {
        try {
            setLoader((prev) => ({ ...prev, tags: { ...prev?.tags, [params?.node?.rowIndex]: true } }));
            const payload = {
                requested_user_code: userCode,
                tvp_user_tags: tagId && tagId[0] ? tagId.map(tag => ({ tag_id: tag?.tag_id || 0, tag_name: tag?.tag_name || "" })) : [{ tag_id: 0, tag_name: "" }],
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERTAGS"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res.body.message);
                sessionStorage.removeItem("user_tags");
                const usertagsdetails = await callautopopulate("user_tags");
                const tags = usertagsdetails?.user_tags || [];
                setOptions(prev => ({ ...prev, user_tags: _.sortBy(tags, "tag_name") }));
                setRowData(prev => _.map(prev, row => row.user_code !== userCode ? row : { ...row, tag_ids: _.map(tagId || [], tag => _.find(tags, t => t.tag_id === tag.tag_id) || tag) }));
                projectStore.setState((prev) => ({ options: { ...prev.options, user_tags: tags } }));
            } else {
                showError("error", res.body.message);
            }
        } catch (error) {
            console.error(error);
            showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, tags: { ...prev?.tags, [params?.node?.rowIndex]: false } }));
        }
    };

    const handleExcelDownload = () => {
        if (_.isEmpty(rowData)) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const allColumns = [
            "Reporting Manager",
            "Employee Id", "Employee Name", "Employe Status", "Email", "Mobile", "Role On Project",
            "Primary TechnoLogy", "Secondary TechnoLogy", "Confirmation Date",
            "Join Date", "Company Age", "Total Experience", "Resign Date", "Leave Date",
            "Business Unit", "Sub Business Unit", "Sub Business Unit 2", "Location",
            "Gender", "Status",
            "Primary Project", "Secondary Project", "State",
            "Present", "Absent", "Regularize", "Work from home", "Outdoor", "GatePass Hours", "Apple Id"
        ];

        const rows = rowData.map(row => ({
            "Reporting Manager": row.reporting_manager_name ?? '',
            "Employee Id": row.employee_id ?? '',
            "Employee Name": row.user_display_name ?? '',
            "Employe Status": row.user_status_name ?? '',
            "Email": row.email_id ?? '',
            "Mobile": row.primary_phone ?? '',
            "Role On Project": row.role_on_project ?? '',
            "Primary TechnoLogy": row.primary_skill_1 ?? '',
            "Secondary TechnoLogy": row.secondary_skill_1 ?? '',
            "Confirmation Date": row.confirmation_date ? row.confirmation_date.split('T')[0] : '',
            "Join Date": row.joining_date ? row.joining_date.split('T')[0] : '',
            "Company Age": row.srkay_exp ?? '',
            "Total Experience": row.total_work_experience ?? '',
            "Resign Date": row.resignation_date ? row.resignation_date.split('T')[0] : '',
            "Leave Date": row.leaving_date ? row.leaving_date.split('T')[0] : '',
            "Business Unit": row.business_unit ?? '',
            "Sub Business Unit": row.sub_business_unit ?? '',
            "Sub Business Unit 2": row.sub_business_unit_2 ?? '',
            "Location": row.location ?? '',
            "Gender": row.gender?.trim() ?? '',
            "Status": row.employee_status ? "Active" : "Inactive",
            "Primary Project": row.primary_project_name ?? '',
            "Secondary Project": row.secondary_project_name ?? '',
            "State": row.state ?? '',
            "Present": row.present_count ?? 0,
            "Absent": row.absent_count ?? 0,
            "Regularize": row.regularize_count ?? 0,
            "Work from home": row.wfh_count ?? 0,
            "Outdoor": row.outdoor_count ?? 0,
            "GatePass Hours": row.total_gatepass_hours ?? 0,
            "Apple Id": row?.ios_device_id ?? '',
        }));

        const headerRow = allColumns;
        const dataRows = rows.map(row =>
            allColumns.map(col => row[col])
        );

        const sheetData = [headerRow, [], ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        const fitToColumn = (data) => {
            const cols = [];
            for (let c = 0; c < data[0].length; ++c) {
                let maxLen = 5;
                for (let r = 0; r < data.length; ++r) {
                    const cell = data[r][c];
                    if (cell && cell.toString().length > maxLen) {
                        maxLen = cell.toString().length;
                    }
                }
                cols.push({ wch: maxLen });
            }
            return cols;
        };

        worksheet['!cols'] = fitToColumn(sheetData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
        XLSX.writeFile(workbook, "teamlist.xlsx", { compression: true });
    };

    useEffect(() => {
        setPinnedBottomRowData([{ employee_id: `Employee: ${rowData.length}` }]);
    }, [rowData]);

    const onFilterChanged = (params) => {
        const displayedRowCount = params?.api?.getDisplayedRowCount();
        setPinnedBottomRowData([{ employee_id: `Employee: ${displayedRowCount}` }]);
    };

    const handleUserUpsertHierachy = async (type, code) => {
        if (_.isEmpty(mapUser.selectedUser) && type !== 'is_verified') {
            showInfo('info', "Please Select User First")
            return;
        }
        const selectedUsersCode = _.pluck(mapUser.selectedUser, 'user_code')
        const payload = {
            "child_user_code": type !== 'is_verified' ? selectedUsersCode?.toString() : code.data.user_code,
            "is_verified": type === 'is_verified' ? true : false,
            "parent_user_code": mapUser.currentUser?.selectedCode || code.data?.parent_user_code

        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("USERHIERARCHYUPSERT"), payload);
            if (!res.body.error_status) {
                showSuccess("success", res.body.message)
                if (type === 'is_verified') {
                    delete code.data.is_action_perform
                    delete code.data.is_requested
                    code.data.is_verified = true
                    code.data.verification_datetime = new Date()
                    let updateData = [...userMapRef.current.props.rowData]
                    const rowNode = userMapRef.current.api.getDisplayedRowAtIndex(code.node.rowIndex);
                    rowNode.setData(updateData[code.node.rowIndex]);
                } else {
                    GetUserHierarchy()
                }
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);

        }
    }

    const GetUserHierarchy = async () => {
        const payload = {
            "parent_user_code": mapUser.currentUser?.selectedCode
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETUSERHIERARCHY"), payload);
            if (!res.body.error_status) {
                setmapRowData(_.sortBy(res.body.data.user_hierarchy, "user_display_name"));
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);

        }
    }

    const handleRemoveUserFromHierarchy = async (event) => {
        const payload = {
            "child_user_code": event.data?.user_code,
            "parent_user_code": event.data?.parent_user_code
        }

        try {
            const res = await services.getInvokeRemote("POST", Urls("REMOVEUSERHIERARCHY"), payload);
            if (!res.body.error_status) {
                showSuccess('sucess', res.body.message)
                let updateData = [...mapRowData]
                updateData.splice(event.data, 1);
                userMapRef.current.api.applyTransaction({ remove: [event.data] });
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);

        }

    }

    const handleUserActiveRequest = async (rowdata) => {
        if (handleData.decision === '') {
            showInfo("Info", "Please Select Any One of These options")
        } else if (handleData.remark === "" && handleData.isRejectClicked) {
            showInfo('Info', "Please Enter Remark")
            return;
        } else {
            const payload = { "request_status_id": (_.findWhere(handleData.statusId, { request_status_name: handleData.isRejectClicked ? 'denied' : 'approve' }))?.request_status_id, "requested_user_code": rowdata.data.user_code, "remark": handleData.remark }
            try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERACTIVATIONREQUEST"), payload);
            if (!res.body.error_status) {
                    setHandleData((prevState) => ({ ...prevState, remark: '', isRejectClicked: false, decision: '' }))
                showSuccess('Sucess', res.body.message)
                    setShowPopUp(false)
                    let updatedData = [...rowData]
                    const handleid = _.findWhere(handleData.statusId, { request_status_name: handleData.isRejectClicked ? 'denied' : 'approve' })
                    updatedData[rowdata.node.rowIndex].request_status_name = handleid?.request_status_name
                    updatedData[rowdata.node.rowIndex].request_status_id = handleid?.request_status_id
                    const rowNode = gridRef.current.api.getDisplayedRowAtIndex(rowdata.node.rowIndex);
                    rowNode.setData(updatedData[rowdata.node.rowIndex]);
            }
        } catch (error) {
            console.error("Error", error);
            }
        }
    }

    const handleSendJiraAccessRequest = async () => {
        try {
            if (_.isEmpty(jiraAccessValues?.project)) {
                showInfo("info", "Please select a project");
                return;
            } else if (_.isEmpty(jiraAccessValues?.group)) {
                showInfo("info", "Please select a group");
                return;
            }
            setJiraBtnLoader(true);
            const payload = {
                requested_user_code: jiraUser?.user?.user_code,
                project_id: jiraAccessValues?.project?.project_id,
                group_id: jiraAccessValues?.group?.group_id
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEUSERPRODUCTREQUEST"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setJiraBtnLoader(false);
                setJiraUser({ show: false, user: {} });
                getTeamOverViewList();
            }
        } catch (error) {
            console.error("Error: ", error);
            setJiraBtnLoader(false);
        }
    }

    const handleEvents = (data, type) => {
        setFilterValues((prev) => ({ ...prev, isChange: true, [type]: [] }));
    }

    const handleSignUp = async () => {
        try {
            const payload = {
                "employee_email_id": confirmationPopup?.data?.email_id,
                "unique_device_id": ""
            }
            const res = await services.getInvokeRemote("POST", Urls("TEAMSIGNUP"), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            }
            else if (!_.isEmpty(res)) {
                showSuccess("Success", res.body.message);
                setConfirmationPopup({ show: false, data: '' })
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const onFilterTextBoxChanged = (e, rowdata) => {
        setSearch(e)
        const val = e?.toLowerCase()?.trim();
        const allRows = rowdata ? [...rowdata] : [...allRowData] || [];
        if (!val) {
            setRowData(allRows);
            return;
        }

        const isPhraseSearch = val?.includes(" ");
        const allFields = _.pluck(columnDefs, "field");
        const filtered = allRows.filter((row) => {
            const text = allFields.map(field => row[field]).filter(Boolean).join(" ").toLowerCase();
            if (isPhraseSearch) {
                return text.includes(val);
            } else {
                return text.split(/\s+/).some((word) => word.includes(val));
            }
        });

        setRowData(filtered);

    };

    return useMemo(() => ({
        onGridReady, onColumnMoved,
        mapUser, setmapUser, mapRowData, mapColDef, handleUserUpsertHierachy, userMapRef,
        loader, rowData, columnDefs, pinnedBottomRowData, gridRef, showPopUp, setShowPopUp, setHandleData, handleData, onSortChanged, getTeamOverViewList, handleUserActiveRequest, categories, userEditData, setUserEditData, showNotes, setShowNotes, notesFlag, setNotesFlag, notesUser, setNotesUser, jiraUser, setJiraUser, groupOpts, jiraAccessValues, setJiraAccessValues, jiraBtnLoader, handleSendJiraAccessRequest, filterValues, setFilterValues, tagRef, handleExcelDownload, handleEvents, options, mappingPopup, setMappingPopup, addUserPopup, setAddUserPopup, confirmationPopup, setConfirmationPopup, handleSignUp, tab, createChart, setCreateChart, showChangeManager, setShowChangeManager, onFilterChanged, onFilterTextBoxChanged, search, autoGroupColumnDef
    }), [onGridReady, mapUser, setmapUser, mapRowData, mapColDef, handleUserUpsertHierachy, userMapRef, onColumnMoved, loader, rowData, columnDefs, pinnedBottomRowData, gridRef, showPopUp, setShowPopUp, handleData, setHandleData, onSortChanged, getTeamOverViewList, handleUserActiveRequest, categories, userEditData, setUserEditData, showNotes, setShowNotes, notesFlag, setNotesFlag, notesUser, setNotesUser, jiraUser, setJiraUser, groupOpts, jiraAccessValues, setJiraAccessValues, jiraBtnLoader, handleSendJiraAccessRequest, filterValues, setFilterValues, tagRef, handleExcelDownload, handleEvents, options, mappingPopup, setMappingPopup, addUserPopup, setAddUserPopup, confirmationPopup, setConfirmationPopup, handleSignUp, tab, createChart, setCreateChart, showChangeManager, setShowChangeManager, onFilterChanged, onFilterTextBoxChanged, search, autoGroupColumnDef])
}